import type { NotificationType } from '@shared/api';

export type { NotificationType };

export const NOTIFICATION_TYPE_LABEL: Record<NotificationType, string> = {
  Memo: 'Memo',
  File: 'File',
  Data: 'Data',
};

/** 알림 한 건 */
export interface Notification {
  id: number;
  portfolioId: number;
  portfolioName: string;
  /** ISO · 없을 수 있다 */
  notifiedAt: string | null;
  type: NotificationType;
  content: string | null;
  isRead: boolean;
}
